import { render, staticRenderFns } from "./Verterapia.vue?vue&type=template&id=75732d5a&scoped=true"
import script from "./Verterapia.vue?vue&type=script&lang=js"
export * from "./Verterapia.vue?vue&type=script&lang=js"
import style0 from "./Verterapia.vue?vue&type=style&index=0&id=75732d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75732d5a",
  null
  
)

export default component.exports